import Signals from "./UISignals";
import UIFacade from "../UIFacade";

export default class UIScaleManager {

  constructor(uiModelView) {

    this.uiModelView = uiModelView
    document.addEventListener("ui:resize", this.onResize)
  }
/*
      detail: {
        width: window.innerWidth,
        height: this.h,
        isMobile: isMobile,
        orientation: this.orientation,
        scale: this.gameScale
      }
 */
  onResize = (data) => {
    this.uiModelView.setParams(data.detail)

    if(UIFacade.model.isMobile !== this.uiModelView.isMobile) {
      UIFacade.model.isMobile = this.uiModelView.isMobile
      Signals.isMobileChanged.dispatch()
    }

    if(UIFacade.model.isMobile) {
      this.updateOrientation()
    }
  }

  updateOrientation() {
    if(window.innerWidth <= window.innerHeight) {
      this.uiModelView.orientation = 'Vm'
    } else {
      this.uiModelView.orientation = 'Hm'
    }
    UIFacade.model.orientation = this.uiModelView.orientation
    Signals.orientationChanged.dispatch(this.uiModelView.orientation)
  }

}